<!--
 * @Author: Latte
 * @Date: 2021-08-09 17:27:55
 * @LAstEditors: Latte
 * @LastEditTime: 2021-10-18 15:58:54
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\systemManagement\diagnosisManagement\teamMgt\detail\index.vue
-->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <el-form :model="teamDetail" label-width="140px" label-position="left">
        <el-row>
          <el-col :span="8">
            <el-form-item label="审核状态：">
              <div>{{ formateAuditStatus }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="审核时间：">
              <div>{{ teamDetail.fullTime }}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="会诊团队 ID：">
              <div>{{ teamDetail.teamID }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="团队名称：">
              <div>{{ teamDetail.teamName }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="团队所属地点：">
              <div>{{ teamDetail.fullPlace }}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="16">
            <el-form-item label="团队介绍：">
              <el-input v-model="teamDetail.teamIntro" type="textarea" rows="5" disabled />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="会诊数量：">
              <div>{{ teamDetail.consultationCount }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="会诊申请数量：">
              <div>{{ teamDetail.consultationReqCount }}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="4">
            <el-form-item label="创建者姓名：">
              <div>{{ teamDetail.fullName }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button @click.stop="creatorDialog = true">查看详情</el-button>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="4">
            <el-form-item label="团队成员数量：">
              <div>{{ teamDetail.teamUserCount }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button @click.stop="memberDialog = true">查看详情</el-button>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" size="small" @click="goBack()">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 团队创建者详情 -->
    <el-dialog title="创建者详情" :visible.sync="creatorDialog" width="60%">
      <el-form :model="teamDetail">
        <el-form-item label="用户 ID：">
          <div>{{ teamDetail.managerInfo.teamID }}</div>
        </el-form-item>
        <el-form-item label="用户名称：">
          <div>{{ teamDetail.fullName }}</div>
        </el-form-item>
        <el-form-item label="用户手机号：">
          <div>{{ teamDetail.managerInfo.mobilePhone }}</div>
        </el-form-item>
        <el-form-item label="用户角色：">
          <div>{{ formateUserRole }}</div>
        </el-form-item>
        <el-form-item label="用户权限：">
          <div>{{ formatePermission }}</div>
        </el-form-item>
        <el-form-item label="用户提交的会诊数量：">
          <div>{{ teamDetail.managerInfo.consultationCount }}</div>
        </el-form-item>
        <el-form-item label="用户提交的会诊申请数量：">
          <div>{{ teamDetail.managerInfo.consultationReqCount }}</div>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 团队成员详情 -->
    <el-dialog title="团队成员详情" :visible.sync="memberDialog" width="60%">
      <el-table ref="table" :data="memberList" border>
        <div v-for="item in memberOpt" :key="item.prop">
          <el-table-column :label="item.label" :prop="item.prop"></el-table-column>
        </div>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      teamDetail: {}, // 团队详情
      creatorDialog: false,
      memberDialog: false,
      memberList: {}, // 成员数组
      memberOpt: Object.freeze([
        { label: "提交的会诊申请数", prop: "consultationReqCount" },
        { label: "成员 ID", prop: "teamUserID" },
        { label: "成员姓名", prop: "fullName" },
        { label: "成员手机号", prop: "mobilePhone" },
        { label: "成员加入时间", prop: "fullTime" },
        { label: "成员角色", prop: "formateRole" },
        { label: "当前成员在会诊系统的角色", prop: "formateUserRole" },
        { label: "权限", prop: "formatePermission" },
        { label: "完成的报告数", prop: "reportCount" },
        { label: "提交的会诊数", prop: "consultationCount" },
      ])
    }
  },
  computed: {
    formateAuditStatus() {
      let auditStatus = this.teamDetail.auditStatus
      let formateAuditStatus = ''
      switch (auditStatus) {
        case (0):
          formateAuditStatus = '未审核'
          break;
        case (1):
          formateAuditStatus = '通过'
          break;
        case (2):
          formateAuditStatus = '未通过'
      }
      return formateAuditStatus
    },
    formatePermission() {
      let perssion = this.teamDetail.managerInfo.permission
      let formatePermission = ''
      switch (perssion) {
        case (0):
          formatePermission = '允许会诊申请但不允许会诊诊断'
          break
        case (1):
          formatePermission = '允许会诊申请和会诊诊断'
      }
      return formatePermission
    },
    formateUserRole() {
      let userRole = this.teamDetail.managerInfo.consultationUserRole
      let formateUserRole = ''
      switch (userRole) {
        case (-1):
          formateUserRole = '普通角色'
          break
        case (0):
          formateUserRole = '医生'
          break
        case (1):
          formateUserRole = '会诊专家'
          break
        case (2):
          formateUserRole = '医生&会诊专家'
      }
      return formateUserRole
    },
  },
  methods: {
    initTeamDetail() {
      this.teamDetail = this.$route.params.teamDetail
      console.log(" ------------------------------------------------")
      console.log("initTeamDetail , this.teamDetail", this.teamDetail)
      console.log(" ------------------------------------------------")
      const teamDate = new Date(this.teamDetail.auditTime).toLocaleDateString()
      const teamTime = new Date(this.teamDetail.auditTime).toLocaleTimeString()

      this.teamDetail.fullTime = new Date(this.teamDetail.auditTime).toLocaleString()
    },

    initMemberList() {
      this.memberList = this.$route.params.teamDetail.threeUserList

      if (this.teamDetail.teamUserCount !== this.teamDetail.threeUserList.length) {
        this.memberList.unshift(this.teamDetail.managerInfo)
      }

      this.memberList.forEach(element => {
        element.fullName = element.firstName + element.lastName
        element.fullTime = new Date(element.joinTime).toLocaleString()

        switch (element.role) {
          case (0):
            element.formateRole = '普通用户'
            break
          case (1):
            element.formateRole = '管理员'
            break
          case (2):
            element.formateRole = '团长，创建者'
        }

        switch (element.consultationUserRole) {
          case (-1):
            element.formateUserRole = '普通角色'
            break
          case (0):
            element.formateUserRole = '医生'
            break
          case (1):
            element.formateUserRole = '会诊专家'
            break
          case (2):
            element.formateUserRole = '医生&会诊专家'
        }

        switch (element.permission) {
          case(0):
            element.formatePermission = '允许会诊申请但不允许会诊诊断'
            break
          case(1):
            element.formatePermission = '允许会诊申请和会诊诊断'
        }
      })
      console.log("this.memberList",this.memberList)
    },

    goBack() {
      this.goBackFlag = 1
      this.$router.go(-1)
    },
  },
  created() {
    this.initTeamDetail()
    this.initMemberList()
  }
}
</script>

<style lang="scss" scoped>
</style>